import { createSelector } from 'reselect'
import pendingRequestsSelector from './pendingRequestsSelector'
import { getResetConfigurationApiUrl } from '../../../constants/apiUrls'

const configurationResetIsPendingSelector = createSelector(
    pendingRequestsSelector,
    (pendingRequests): boolean => (pendingRequests[getResetConfigurationApiUrl()] || 0) > 0,
)

export default configurationResetIsPendingSelector
